// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__14M7W","text":"styles_text__FffwK","chevron":"styles_chevron__Xwwz8","skeleton-animation":"styles_skeleton-animation__IX5Tb"};